import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { company, gradientColor } from "./constants";

function AboutUs() {
  return (
    <>
      <Box
        id="about"
        sx={{
          margin: "auto",
          marginBottom: 15,
          width: {
            xs: "85vw",
            md: "55vw",
          },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            color: "#0a1530",
            marginBottom: 5,
            lineHeight: 1,

            fontSize: {
              xs: "1.85rem",
              sm: "2.5rem",
              md: "3.5rem",
            },
            padding: {
              xs: "0",
              md: "20px",
            },
          }}
        >
          Leading Healthcare
          <span
            style={{
              background: gradientColor,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            Equipment Provider{" "}
          </span>{" "}
          in Pakistan
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: "0.9rem",
              md: "1.2rem",
            },
            lineHeight: "1.5",
            width: {
              xs: "100%",
              md: "80%",
            },
            margin: "auto",
            textAlign: {
              xs: "justify",
              md: "center",
            },
          }}
        >
          {company.description}
        </Typography>
        <Button
          variant="contained"
          href="#products"
          sx={{
            padding: "8px 20px",
            backgroundColor: "#0a1530",
            fontWeight: "700",
            fontSize: "0.85rem",
            borderRadius: "20px",
            transition: "background 2s ease",
            marginTop: 5,
            "&:hover": {
              background: gradientColor,
            },
          }}
        >
          Explore Our Products
        </Button>
      </Box>
    </>
  );
}
export default AboutUs;
